import { apiAddress } from "../../config/server";
import { IShiftEnrolment } from "../../types/shifts/ShiftEnrolment";
import { ApiBase } from "./baseApi";

export default class ShiftEnrolmentsApi extends ApiBase {
  static ShiftEnrolmentsApiAddress = `${apiAddress}/api/shift/enrolments/`;

  static getByShiftId(shiftId: string): Promise<IShiftEnrolment[]> {
    return this.get<IShiftEnrolment[]>(
      `${this.ShiftEnrolmentsApiAddress}shift/${shiftId}`,
    ).then((response) => response.data.data);
  }

  static updateShiftEnrolment(
    enrolment: Partial<IShiftEnrolment>,
  ): Promise<IShiftEnrolment> {
    if (!(enrolment.shift && enrolment.person)) {
      throw new Error(
        "updateShiftEnrolment was missing parameters shift | person",
      );
    }
    return this.patch<IShiftEnrolment>(
      `${this.ShiftEnrolmentsApiAddress}${enrolment.shift}/${enrolment.person}`,
      enrolment,
    ).then((response) => response.data.data);
  }

  static archiveShiftEnrolment(
    shift: string,
    person: string,
    shiftSessionId?: string,
  ): Promise<boolean> {
    const queryParams = this.prepareQueryParams({ shiftSessionId });
    return this.delete<null>(
      `${this.ShiftEnrolmentsApiAddress}${shift}/${person}${queryParams}`,
    ).then((response) => response.data.success || false);
  }
}
